import { TranslationNamespaces } from "configs/i18n/TranslationTypes";

export function translateCategory(id: number) {
  const keyRoot = TranslationNamespaces["categories"] + ":" + id;
  return {
    name: keyRoot + ".name",
  };
}
